module.exports = __webpack_public_path__ + "img/数据中心.9ceba4be.png";